import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOverview, IOverviewSearchForm, IOverviewState } from 'types/overview';

const initialState: IOverviewState = {
    data: {
        campaigns: [],
    },
    overviewSearchForm: {
        searchKeyWord: '',
        status: [],
        startDate: '',
        endDate: '',
        region: [],
        device: [],
    },
};

const overviewSlice = createSlice({
    name: 'overview',
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<IOverview>) => {
            state.data = action.payload.data;
        },
        setOverviewSearchForm: (
            state,
            action: PayloadAction<IOverviewSearchForm>
        ) => {
            state.overviewSearchForm = {
                ...state.overviewSearchForm,
                ...action.payload,
            };
        },
        clearOverviewSearchForm: (state) => {
            state.overviewSearchForm = initialState.overviewSearchForm;
        },
    },
});

export const { setData, setOverviewSearchForm, clearOverviewSearchForm } =
    overviewSlice.actions;

export default overviewSlice.reducer;
